import { useParams } from 'react-router-dom';
import { AuthSurface, Button } from '@sakhtar/design-system/react';
import { tenantBasePath } from '../../lib/tenant.js';

/**
 * UI_REFERENCE_SOURCE:
 * section: Sakhtar Pilot P0 §2.5.3 SESSION EXPIRED
 * canonical pattern: AuthSurface, centered — single message + one primary
 *   recovery action (re-login)
 *
 * Subtitle copy matches the design's own text (fixed 2026-09-17): explains
 * *why* (inactivity, not an error) and reassures no unsaved work was lost
 * — was a shorter, generic "برای ادامه دوباره وارد شوید" before this fix.
 */
export function SessionExpiredPage() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return null;

  return (
    <AuthSurface
      title="نشست شما منقضی شده"
      subtitle="به دلیل نبود فعالیت، نشست شما پایان یافت. تغییرات ذخیره‌نشده باقی نمانده است — برای ادامه دوباره وارد شوید."
    >
      <Button
        style={{ width: '100%' }}
        onClick={() => {
          window.location.href = `${tenantBasePath(slug)}/login`;
        }}
      >
        ورود دوباره
      </Button>
    </AuthSurface>
  );
}
